var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGooglePay = function SvgGooglePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 63 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google-pay_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.2 0h56a3.2 3.2 0 0 1 3.2 3.2v33.6a3.2 3.2 0 0 1-3.2 3.2h-56A3.2 3.2 0 0 1 0 36.8V3.2A3.2 3.2 0 0 1 3.2 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.808 0H13.584C2.577 0-6.43 9-6.43 20s9.007 20 20.014 20h35.224c11.008 0 20.014-9 20.014-20S59.816 0 48.808 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C4043",
    d: "M29.46 21.42v6.05h-1.92V12.53h5.093c1.29 0 2.391.43 3.292 1.29q1.38 1.29 1.38 3.15c0 1.27-.46 2.32-1.38 3.17-.89.85-1.991 1.27-3.292 1.27H29.46zm0-7.05v5.21h3.213c.76 0 1.4-.26 1.9-.77.511-.51.771-1.13.771-1.83 0-.69-.26-1.3-.77-1.81-.5-.53-1.13-.79-1.901-.79H29.46zM42.33 16.91q2.132 0 3.363 1.14t1.23 3.12v6.3h-1.83v-1.42h-.08c-.791 1.17-1.852 1.75-3.173 1.75-1.13 0-2.072-.33-2.832-1s-1.14-1.5-1.14-2.5q0-1.59 1.2-2.52c.8-.63 1.871-.94 3.202-.94 1.141 0 2.082.21 2.812.63v-.44c0-.67-.26-1.23-.79-1.7s-1.151-.7-1.862-.7c-1.07 0-1.921.45-2.541 1.36l-1.692-1.06c.931-1.35 2.312-2.02 4.133-2.02m-2.481 7.42c0 .5.21.92.64 1.25.42.33.92.5 1.491.5q1.215 0 2.162-.9c.63-.6.95-1.3.95-2.11-.6-.47-1.43-.71-2.502-.71-.78 0-1.43.19-1.95.56-.531.39-.791.86-.791 1.41M57.368 17.24l-6.405 14.72h-1.981l2.382-5.15-4.223-9.57h2.091l3.042 7.34h.04l2.962-7.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M21.815 20.2q-.002-.938-.16-1.8h-8.053v3.3h4.638a3.97 3.97 0 0 1-1.721 2.658V26.5h2.76c1.613-1.49 2.536-3.695 2.536-6.299"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M16.523 24.358c-.769.518-1.759.821-2.916.821-2.237 0-4.134-1.506-4.814-3.536H5.945v2.208a8.57 8.57 0 0 0 7.662 4.718c2.315 0 4.26-.76 5.677-2.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FABB05",
    d: "M8.523 20.005c0-.57.095-1.121.268-1.639v-2.208H5.943a8.5 8.5 0 0 0-.912 3.847c0 1.384.33 2.69.912 3.847l2.848-2.208a5.2 5.2 0 0 1-.268-1.639"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E94235",
    d: "M13.607 14.83c1.264 0 2.395.435 3.289 1.285l2.447-2.443c-1.486-1.383-3.424-2.232-5.736-2.232-3.35 0-6.25 1.92-7.662 4.718l2.848 2.208c.68-2.03 2.577-3.536 4.814-3.536"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google-pay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h62.4v40H0z"
  })))));
};
export default SvgGooglePay;